import React, { useState, useEffect, useRef } from "react";
import Index from "../../../../../component/Index";
import ContainerIndex from "../../../../Index";
import { styled } from "@mui/material/styles";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useDispatch } from "react-redux";
import { Autocomplete, ButtonGroup, Button } from "@mui/material";
import { Controller } from "react-hook-form";
import * as XLSX from "xlsx/xlsx.mjs";
import {
  getWebViewLedgerReportDataApiHandler,
  getWebViewLedgerReportFilterOptionsApiHandler,
  getWebViewCompanyAddressApiHandler,
  generateReportPdfApiHandler,
} from "../../../../../services/AdminIndex";
import LoadingSpinner from "../../../../../component/LoadingSpinner";
import ReportGeneratingModal from "../../../../../component/ReportGeneratingModal";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const Item = styled(Index.Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function WebViewLedgerReport() {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = Index.useForm();
  const { companyId, selectedYearStart, selectedYearEnd } = useParams();
  const filterRef = useRef();
  const printRef = useRef();
  const dispatch = useDispatch();
  const [isLoading, setIdLoading] = useState(false);
  // PDF generation runs automatically once report data loads (see the
  // handlePrint useEffect below), with no click behind it — window.open()
  // fired from that gesture-less async flow gets silently popup-blocked in
  // every major browser. So instead of forcing a new tab open, we surface
  // a real button once the PDF is ready and let the user's own click open
  // it — a genuine click always survives the popup blocker.
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [filteredSubmitedOptions, setFilteredSubmitedOptions] = useState();
  const [companyAddress, setCompanyAddress] = useState({});

  const reportType = [
    { value: "detailReport", title: "Detail Report" },
    { value: "summaryReport", title: "Summary Report" },
    {
      value: "letterReport",
      title: "Letter Reort",
    },
  ];

  const addressType = [
    { value: 1, title: 1 },
    { value: 2, title: 2 },
  ];

  const balanceFilterOptions = [
    { value: "all", title: "All" },
    { value: "negative", title: "Only Negative(-)" },
    { value: "positive", title: "Only Positive(+)" },
    { value: "zero", title: "Only Zero Balance" },
  ];

  const { loading, token } = Index.useSelector((state) => {
    return state.ERPAdminReducer;
  });

  //   const handlePrint = useReactToPrint({
  //     content: () => printRef.current,
  //     bodyClass: "padding-10",
  //   });

  const generateAndSavePDF = async (printIframe) => {
    // The old approach rasterized this whole iframe into one html2canvas
    // canvas and paginated it via jsPDF — a large ledger (lots of
    // transactions) blows past the browser's canvas pixel/memory limit and
    // the PDF just fails to build. Sending the iframe's real HTML to the
    // backend so Puppeteer can print it natively has no such ceiling.
    setPdfPreviewUrl(null);
    const doc = printIframe.contentWindow.document;
    if (!doc.querySelector("base")) {
      const base = doc.createElement("base");
      base.href = `${window.location.origin}/`;
      doc.head.prepend(base);
    }
    // Shrink the print font so all the report's rows/columns fit on the
    // page instead of getting cut off — scoped to this exported document
    // only, so the shared .table-th/.table-td classes (used on-screen
    // across the whole app) are untouched.
    const pdfFontStyle = doc.createElement("style");
    pdfFontStyle.textContent = `
      body, table, td, th, .table-th, .table-td, .MuiTableCell-root {
        font-size: 8px !important;
        line-height: 1.3 !important;
      }
      .table-th, .table-td, .MuiTableCell-root {
        padding: 2px 4px !important;
      }
      table { width: 100% !important; table-layout: auto !important; }
    `;
    doc.head.appendChild(pdfFontStyle);
    const html = `<!DOCTYPE html>${doc.documentElement.outerHTML}`;

    try {
      generateReportPdfApiHandler({
        html,
        fileName: "ledger-report",
      }).then((response) => {
        setIdLoading(false);
        if ((response.status == 201 || response.status == 200) && response?.data) {
          // PDF is generated in the background as soon as the report data
          // loads, but we never auto-open it — only the user's own click on
          // the "View PDF" button (rendered below) opens it.
          setPdfPreviewUrl(response.data);
        } else {
          toast.error("Failed to generate report PDF");
        }
      });
    } catch (e) {
      setIdLoading(false);
    }
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    print: async (printIframe) => {
      await generateAndSavePDF(printIframe);
    },
  });

  useEffect(() => {
    if (reportData?.length > 0) {
      handlePrint();
    }
  }, [reportData]);

  const handleScrollToTop = (ref) => {
    filterRef.current.scrollIntoView();
  };

  useEffect(() => {
    setValue("selectedAddress", 1);
  }, []);
  useEffect(() => {
    setValue("accounts", []);
    setValue("groups", []);
    setValue("printPaymentDetails", false);
    setValue("printPanTan", false);
    setValue("printGSTNo", false);
    setValue("printAddress", false);
    setValue("balanceFilter", "all");

    setValue("letterDate", dayjs());
    setValue("fromDate", dayjs(selectedYearStart));
    setValue("toDate", dayjs(selectedYearEnd));
  }, [selectedYearStart]);

  useEffect(() => {
    const selectedGroupsIds = watch("groups")?.map((item) => {
      return item.Id;
    });
    if (selectedGroupsIds?.length) {
      const filteredAccounts = accounts?.filter((item) => {
        return selectedGroupsIds?.includes(item?.groupName);
      });
      setFilteredAccounts(filteredAccounts);
    } else {
      setFilteredAccounts(accounts);
    }
  }, [watch("groups")]);
  const exportToExcel = () => {
    // Convert table to sheet
    const ws = XLSX?.utils?.table_to_sheet(printRef.current);
    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

    if (watch("reportType") == "detailReport") {
      data.forEach((row) => {
        if (row.length > 1) {
          if (row?.indexOf("Set Off") != -1 || row?.indexOf("Action") != -1) {
            row.pop(); // Remove the last element from each row
          }
        }
      });
    }
    // return false;
    data.splice(2, 0, []);
    const newWs = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX?.utils?.book_new();
    XLSX?.utils?.book_append_sheet(wb, newWs, "Sales-Order");
    XLSX.writeFile(wb, "sales-Order.xlsx");
  };

  const getReportFilterOptions = () => {
    dispatch({ type: "LOADER_START" });
    try {
      getWebViewLedgerReportFilterOptionsApiHandler(companyId, false).then(
        async (data) => {
          dispatch({ type: "LOADER_START" });
          if (data.status === 201 || data.status === 200) {
            setAccounts(data?.data?.accounts);
            setFilteredAccounts(data?.data?.accounts);
            setGroups(data?.data?.groups);

            dispatch({ type: "LOADER_END" });
          } else {
            dispatch({ type: "ADMIN_ERROR_HANDLER", payload: data });
          }
        }
      );
    } catch (error) {
    }
  };

  const getCompanyAddress = () => {
    try {
      getWebViewCompanyAddressApiHandler(companyId).then(async (data) => {
        if (data.status === 201 || data.status === 200) {
          setCompanyAddress(data?.data?.[0]);
        } else {
          dispatch({ type: "ADMIN_ERROR_HANDLER", payload: data });
        }
      });
    } catch (error) {
    }
  };

  useEffect(() => {
    getReportFilterOptions();
    getCompanyAddress();
  }, []);

  const submit = (data) => {
    setIdLoading(true);
    setFilteredSubmitedOptions(data);
    if (data?.accounts?.length) {
      const selectedAccountsId = data.accounts?.map((item) => {
        return item.id;
      });
      data.accounts = JSON.stringify(selectedAccountsId);
    } else {
      // const selectedAccountsId = accounts?.map((item) => {
      //   return item.id;
      // });
      // data.accounts = JSON.stringify(selectedAccountsId);
      delete data.accounts;
    }
    if (data?.groups?.length) {
      const selectedGroupsId = data.groups?.map((item) => {
        return item.Id;
      });
      data.groups = JSON.stringify(selectedGroupsId);
    } else {
      // const selectedGroupsId = groups?.map((item) => {
      //   return item.Id;
      // });
      // data.groups = JSON.stringify(selectedGroupsId);
      delete data.groups;
    }
    data.fromDate = dayjs(data.fromDate).format("YYYY-MM-DD");
    data.toDate = dayjs(data?.toDate).format("YYYY-MM-DD");

    data.type = data.reportType;
    data.companyId = companyId;
    if (data.balanceFilter && data.balanceFilter !== "all") {
      data.balanceFilter = data.balanceFilter;
    } else {
      delete data.balanceFilter;
    }
    // return false;
    try {
      getWebViewLedgerReportDataApiHandler(
        data
      ).then(async (response) => {
        // dispatch({ type: "LOADER_START" });
        // return false;
        if (response.status === 404) {
          setIdLoading(false);
          setReportData([]);
          dispatch({ type: "LOADER_END" });
          toast.error(response?.message || "Data not found");
        } else if (response.status === 201 || response.status === 200) {
          let finalData = [];
          let filteredData = [];
          if (watch("reportType") == "detailReport") {
            filteredData = response?.data?.filter((ele) => ele?.accountData);
            let formatedData = filteredData?.map((ele) => {
              return {
                ...ele,
                address: parseData(ele?.address),
                accountData: parseData(ele?.accountData),
              };
            });

            finalData = formatedData;
          } else if (watch("reportType") == "summaryReport") {
            finalData = response?.data;
          } else if (watch("reportType") == "letterReport") {
            filteredData = response?.data?.filter((ele) => ele?.accountData);
            let formatedData = filteredData?.map((ele) => {
              return {
                ...ele,
                address: parseData(ele?.address),
                accountData: parseData(ele?.accountData),
              };
            });

            finalData = formatedData;
          }

          // ==========================================
          // YAHAN PAR APNA FILTER CODE LAGAYEN
          // ==========================================
          const currentFilter = watch("balanceFilter");
          let filteredReportData = finalData;

          if (currentFilter && currentFilter !== "all") {
            filteredReportData = finalData.filter((row) => {
              let balance = 0;

              if (watch("reportType") === "summaryReport") {
                balance = Number(row?.balance || 0);
              }
              else {
                const lastEntry =
                  row?.accountData?.[row?.accountData?.length - 1];
                balance = Number(lastEntry?.balance || 0);
              }

              if (currentFilter === "negative") return balance < 0;
              if (currentFilter === "positive") return balance > 0;
              if (currentFilter === "zero") return balance === 0;

              return true;
            });
          }
          // ==========================================

          setReportData(filteredReportData);
          dispatch({ type: "LOADER_END" });
          // Close the waiting modal as soon as the data preview is ready —
          // PDF generation continues in the background and the "View PDF"
          // button appears separately once it's done.
          setIdLoading(false);
          if (!filteredReportData?.length) {
            toast.error("Data not found");
          }
        } else {
          setIdLoading(false);
          dispatch({ type: "ADMIN_ERROR_HANDLER", payload: data });
        }
      }
      );
    } catch (error) {
      setIdLoading(false);
    }
  };
  const parseData = (data) => {
    try {
      // if plain js
      if (data) {
        let result = JSON.parse(data);
        return result;
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  };
  const reportContent = (reportData) => {
    if (watch("reportType") == "detailReport") {
      return (
        <Index.Box className="card-spacing">
          <Index.Box
            className="card-spacing page-table-main web-view-ledger-table-main"
          >
            <TableContainer
              component={Paper}
              className="table-container summary-table-container"
            >
              <div ref={printRef}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="table"
                >
                  <TableHead className="table-head">
                    <TableRow>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                        colSpan="100%"
                      >
                        <Index.Box className="table-summary-bg">
                          <Index.Typography
                            variant="h4"
                            component="h4"
                            className="view-titles"
                          >
                            Ledger Report
                          </Index.Typography>
                          <Index.Typography
                            variant="h5"
                            component="h5"
                            className="view-subtitle"
                          ></Index.Typography>
                        </Index.Box>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="table-body">
                    {/* <TableRow className="table-row">
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                      >
                        Date
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                      >
                        Doc. No
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                      >
                        Description
                      </TableCell>
                      {watch("withRate") ? (
                        <TableCell
                          component="th"
                          scope="row"
                          className="table-th"
                        >
                          Rate
                        </TableCell>
                      ) : (
                        <></>
                      )}
                      {watch("withAmount") ? (
                        <TableCell
                          component="th"
                          scope="row"
                          className="table-th"
                        >
                          Amount
                        </TableCell>
                      ) : (
                        <></>
                      )}
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                      >
                        Inward
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                      >
                        Outward
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                      >
                        Balance
                      </TableCell>
                    </TableRow> */}
                    {reportData?.map((row, index) => {
                      return (
                        <>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Ledger Of
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={4}
                            >
                              {row?.accountName}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Group Name
                            </TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            >
                              {row?.GroupName}
                            </TableCell>
                          </TableRow>
                          {watch("printAddress") && (
                            <>
                              <TableRow className="table-row">
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className="table-th"
                                >
                                  Address
                                </TableCell>
                                <TableCell
                                  component="td"
                                  scope="row"
                                  className="table-td"
                                  colSpan={"100%"}
                                >
                                  {row?.address?.[watch("selectedAddress") - 1]
                                    ?.address1
                                    ? `${row.address[
                                      watch("selectedAddress") - 1
                                    ].address1
                                    },`
                                    : ""}
                                  {row?.address?.[watch("selectedAddress") - 1]
                                    ?.address2
                                    ? `${row.address[
                                      watch("selectedAddress") - 1
                                    ].address2
                                    },`
                                    : ""}
                                  {row?.address?.[watch("selectedAddress") - 1]
                                    ?.address3
                                    ? `${row.address[
                                      watch("selectedAddress") - 1
                                    ].address3
                                    },`
                                    : ""}
                                </TableCell>
                              </TableRow>
                              <TableRow className="table-row">
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className="table-th"
                                ></TableCell>
                                <TableCell
                                  component="td"
                                  scope="row"
                                  className="table-td"
                                  colSpan={"100%"}
                                >
                                  {row?.address?.[watch("selectedAddress") - 1]
                                    ?.areaName
                                    ? `${row.address[
                                      watch("selectedAddress") - 1
                                    ].areaName
                                    },`
                                    : ""}
                                  {row?.address?.[watch("selectedAddress") - 1]
                                    ?.cityName
                                    ? `${row.address[
                                      watch("selectedAddress") - 1
                                    ].cityName
                                    },`
                                    : ""}
                                  {row?.address?.[watch("selectedAddress") - 1]
                                    ?.Statename
                                    ? `${row.address[
                                      watch("selectedAddress") - 1
                                    ].Statename
                                    }-`
                                    : ""}
                                  {row?.address?.[watch("selectedAddress") - 1]
                                    ?.pin
                                    ? `${row.address[
                                      watch("selectedAddress") - 1
                                    ].pin
                                    }`
                                    : ""}
                                </TableCell>
                              </TableRow>
                            </>
                          )}

                          {watch("printPanTan") && (
                            <>
                              <TableRow className="table-row">
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className="table-th"
                                >
                                  PAN No.
                                </TableCell>
                                <TableCell
                                  component="td"
                                  scope="row"
                                  className="table-td"
                                  colSpan={4}
                                >
                                  {row?.PANNo}
                                </TableCell>
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className="table-th"
                                >
                                  TAN No.
                                </TableCell>
                                <TableCell
                                  component="td"
                                  scope="row"
                                  className="table-td"
                                >
                                  {row?.TANNo}
                                </TableCell>
                              </TableRow>
                            </>
                          )}

                          {watch("printGSTNo") && (
                            <>
                              <TableRow className="table-row">
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className="table-th"
                                >
                                  GST No.
                                </TableCell>
                                <TableCell
                                  component="td"
                                  scope="row"
                                  className="table-td"
                                  colSpan={4}
                                >
                                  {row?.GST}
                                </TableCell>
                              </TableRow>
                            </>
                          )}

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Doc
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Date
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Cheque No.
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Particulars
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              Debit
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              Credit
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              Balance
                            </TableCell>
                          </TableRow>
                          {row?.accountData?.map((acEntry, index) => {
                            return (
                              <>
                                <TableRow className="table-row">
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {acEntry?.transNo}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {moment(acEntry?.createdAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {acEntry?.cheque}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {acEntry?.accountName}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td text-align-right"
                                  >
                                    {acEntry?.type == "DR"
                                      ? Number(acEntry?.amount).toFixed(2)
                                      : ""}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td text-align-right"
                                  >
                                    {!acEntry?.isOpening &&
                                      acEntry?.type == "CR"
                                      ? Number(acEntry?.amount).toFixed(2)
                                      : ""}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td text-align-right"
                                  >
                                    {Number(acEntry?.balance).toFixed(2)}
                                  </TableCell>
                                </TableRow>
                                {watch("printPaymentDetails") &&
                                  parseData(acEntry?.billData)?.map(
                                    (bill, index) => {
                                      return (
                                        <>
                                          <TableRow className="table-row">
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            >
                                              {bill?.billNo !== "DISCOUNT" &&
                                                bill?.billNo !== "TDS" &&
                                                bill?.billNo !== "INTEREST" &&
                                                bill?.billNo !== "EXPENSE"
                                                ? `Doc. No: ${bill?.billNo}`
                                                : `${bill?.billNo}`}{" "}
                                              {"/"} Amt: {bill?.netAmount}
                                            </TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td text-align-right"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td text-align-right"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td text-align-right"
                                            ></TableCell>
                                          </TableRow>
                                        </>
                                      );
                                    }
                                  )}
                              </>
                            );
                          })}
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Total
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              {Number(
                                row?.accountData?.reduce(
                                  (total, transaction) => {
                                    return transaction.type === "DR"
                                      ? total + transaction?.amount
                                      : total;
                                  },
                                  0
                                )
                              ).toFixed(2)}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              {Number(
                                row?.accountData?.reduce(
                                  (total, transaction) => {
                                    return transaction.type === "CR"
                                      ? total + transaction?.amount
                                      : total;
                                  },
                                  0
                                )
                              ).toFixed(2)}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              {Number(
                                row?.accountData?.[row?.accountData?.length - 1]
                                  ?.balance
                              ).toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}

                    {watch("isSubmitted") && !reportData?.length ? (
                      <TableRow className="table-row">
                        <TableCell
                          component="td"
                          scope="row"
                          className="table-td text-center"
                          colSpan={"100%"}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </div>
            </TableContainer>
          </Index.Box>
        </Index.Box>
      );
    } else if (watch("reportType") == "summaryReport") {
      return (
        <Index.Box className="card-spacing">
          <Index.Box className="page-table-main web-summary-report-table-main">
            <TableContainer
              component={Paper}
              className="table-container summary-table-container"
            >
              <div ref={printRef}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="table"
                >
                  <TableHead className="table-head">
                    <TableRow>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                        colSpan="100%"
                      >
                        <Index.Box className="table-summary-bg">
                          <Index.Typography
                            variant="h4"
                            component="h4"
                            className="view-titles"
                          >
                            Ledger Report
                          </Index.Typography>
                          <Index.Typography
                            variant="h5"
                            component="h5"
                            className="view-subtitle"
                          ></Index.Typography>
                        </Index.Box>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="table-body">
                    <TableRow className="table-row">
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                      >
                        Party Name
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th text-align-right"
                      >
                        Opening Bal.
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th text-align-right"
                      >
                        DR Amt.
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th text-align-right"
                      >
                        CR Amt.
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th text-align-right"
                      >
                        Closing Bal.
                      </TableCell>
                    </TableRow>
                    {reportData?.map((row, index) => {
                      return (
                        <>
                          <TableRow className="table-row">
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            >
                              {row?.accountName}
                            </TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td text-align-right"
                            >
                              {Number(row?.openingBalance || 0).toFixed(2)}
                            </TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td text-align-right"
                            >
                              {Number(row?.drAmount).toFixed(2)}
                            </TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td text-align-right"
                            >
                              {Number(row?.crAmount).toFixed(2)}
                            </TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td text-align-right"
                            >
                              {Number(row?.balance).toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}

                    {watch("isSubmitted") && !reportData?.length ? (
                      <TableRow className="table-row">
                        <TableCell
                          component="td"
                          scope="row"
                          className="table-td text-center"
                          colSpan={"100%"}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </div>
            </TableContainer>
          </Index.Box>
        </Index.Box>
      );
    } else if (watch("reportType") == "letterReport") {
      return (
        <Index.Box className="card-spacing">
          <Index.Box className="page-table-main web-letter-report-table-main">
            <TableContainer
              component={Paper}
              className="table-container summary-table-container"
            >
              <div ref={printRef}>
                <Table
                  sx={{ minWidth: 650 }}
                  aria-label="simple table"
                  className="table"
                >
                  <TableHead className="table-head">
                    <TableRow>
                      <TableCell
                        component="th"
                        scope="row"
                        className="table-th"
                        colSpan="100%"
                      >
                        <Index.Box className="table-summary-bg">
                          <Index.Typography
                            variant="h4"
                            component="h4"
                            className="view-titles"
                          >
                            Ledger Report
                          </Index.Typography>
                          <Index.Typography
                            variant="h5"
                            component="h5"
                            className="view-subtitle"
                          ></Index.Typography>
                        </Index.Box>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className="table-body">
                    {reportData?.map((row, index) => {
                      return (
                        <>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              <Index.Typography className="table-data-text">
                                {companyAddress?.Company_name}
                              </Index.Typography>
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                              colSpan={"100%"}
                            >
                              {companyAddress?.o_add1
                                ? `${companyAddress?.o_add1},`
                                : ""}
                              {companyAddress?.o_add2
                                ? `${companyAddress?.o_add2},`
                                : ""}
                              {companyAddress?.o_add3
                                ? `${companyAddress?.o_add3},`
                                : ""}
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                              colSpan={"100%"}
                            >
                              {companyAddress?.cityName
                                ? `${companyAddress?.cityName},`
                                : ""}
                              {companyAddress?.Statename
                                ? `${companyAddress?.Statename}-`
                                : ""}
                              {companyAddress?.o_pin
                                ? `${companyAddress?.o_pin}`
                                : ""}
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              To
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              {row?.accountName}
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                              colSpan={"100%"}
                            >
                              {row?.address?.[watch("selectedAddress") - 1]
                                ?.address1
                                ? `${row.address[watch("selectedAddress") - 1]
                                  .address1
                                },`
                                : ""}
                              {row?.address?.[watch("selectedAddress") - 1]
                                ?.address2
                                ? `${row.address[watch("selectedAddress") - 1]
                                  .address2
                                },`
                                : ""}
                              {row?.address?.[watch("selectedAddress") - 1]
                                ?.address3
                                ? `${row.address[watch("selectedAddress") - 1]
                                  .address3
                                },`
                                : ""}
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                              colSpan={"100%"}
                            >
                              {row?.address?.[watch("selectedAddress") - 1]
                                ?.areaName
                                ? `${row.address[watch("selectedAddress") - 1]
                                  .areaName
                                },`
                                : ""}
                              {row?.address?.[watch("selectedAddress") - 1]
                                ?.cityName
                                ? `${row.address[watch("selectedAddress") - 1]
                                  .cityName
                                },`
                                : ""}
                              {row?.address?.[watch("selectedAddress") - 1]
                                ?.Statename
                                ? `${row.address[watch("selectedAddress") - 1]
                                  .Statename
                                }-`
                                : ""}
                              {row?.address?.[watch("selectedAddress") - 1]?.pin
                                ? `${row.address[watch("selectedAddress") - 1]
                                  .pin
                                }`
                                : ""}
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                            >
                              Letter Date
                            </TableCell>
                            <TableCell
                              component="td"
                              scope="row"
                              className="table-td"
                              colSpan={"100%"}
                            >
                              {moment(watch("letterDate")).format("DD-MM-YYYY")}
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Doc
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Date
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Cheque No.
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Particulars
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              Debit
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              Credit
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              Balance
                            </TableCell>
                          </TableRow>
                          {row?.accountData?.map((acEntry, index) => {
                            return (
                              <>
                                <TableRow className="table-row">
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {acEntry?.transNo}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {moment(acEntry?.createdAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {acEntry?.cheque}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td"
                                  >
                                    {acEntry?.accountName}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td text-align-right"
                                  >
                                    {acEntry?.type == "DR"
                                      ? Number(acEntry?.amount).toFixed(2)
                                      : ""}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td text-align-right"
                                  >
                                    {acEntry?.type == "CR"
                                      ? Number(acEntry?.amount).toFixed(2)
                                      : ""}
                                  </TableCell>
                                  <TableCell
                                    component="td"
                                    scope="row"
                                    className="table-td text-align-right"
                                  >
                                    {Number(acEntry?.balance).toFixed(2)}
                                  </TableCell>
                                </TableRow>
                                {watch("printPaymentDetails") &&
                                  parseData(acEntry?.billData)?.map(
                                    (bill, index) => {
                                      return (
                                        <>
                                          <TableRow className="table-row">
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td"
                                            >
                                              Bill No: {bill?.billNo} {"/"}{" "}
                                              Amount: {bill?.netAmount}
                                            </TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td text-align-right"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td text-align-right"
                                            ></TableCell>
                                            <TableCell
                                              component="td"
                                              scope="row"
                                              className="table-td text-align-right"
                                            ></TableCell>
                                          </TableRow>
                                        </>
                                      );
                                    }
                                  )}
                              </>
                            );
                          })}
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            >
                              Total
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              {Number(
                                row?.accountData?.reduce(
                                  (total, transaction) => {
                                    return transaction.type === "DR"
                                      ? total + transaction?.amount
                                      : total;
                                  },
                                  0
                                )
                              ).toFixed(2)}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              {Number(
                                row?.accountData?.reduce(
                                  (total, transaction) => {
                                    return transaction.type === "CR"
                                      ? total + transaction?.amount
                                      : total;
                                  },
                                  0
                                )
                              ).toFixed(2)}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th text-align-right"
                            >
                              {Number(
                                row?.accountData?.[row?.accountData?.length - 1]
                                  ?.balance
                              ).toFixed(2)}
                            </TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              Ledger
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            ></TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            ></TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              for {`${row?.accountName}`}
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            ></TableCell>
                          </TableRow>
                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            ></TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                              colSpan={"100%"}
                            >
                              Authorised Signatory
                            </TableCell>
                          </TableRow>

                          <TableRow className="table-row">
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              className="table-th"
                            ></TableCell>
                          </TableRow>
                        </>
                      );
                    })}

                    {watch("isSubmitted") && !reportData?.length ? (
                      <TableRow className="table-row">
                        <TableCell
                          component="td"
                          scope="row"
                          className="table-td text-center"
                          colSpan={"100%"}
                        >
                          No Data Found
                        </TableCell>
                      </TableRow>
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </div>
            </TableContainer>
          </Index.Box>
        </Index.Box>
      );
    }
  };

  if (loading) {
    <LoadingSpinner></LoadingSpinner>;
  } else {
    return (
      <div>
        <ReportGeneratingModal open={isLoading} />
        <Index.Box className="main_content">
          <Index.Box className="web-main-content">
            <Index.Box className="over-text-scroll">
              <Index.Box className="admin-dashboard-list-row">
                <Index.Box
                  className="report-main-box report-main-box-set"
                  ref={filterRef}
                >
                  <form
                    className="form-content"
                    onSubmit={handleSubmit(submit)}
                  >
                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group date-of-purchase">
                        <Index.FormHelperText className="lable-control">
                          From Date
                        </Index.FormHelperText>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <Controller
                              control={control}
                              {...register("fromDate")}
                              render={({ field: { onChange, value } }) => (
                                <MobileDatePicker
                                  // disableFuture={true}
                                  className="custom-form-control"
                                  format="DD/MM/YYYY"
                                  value={value}
                                  minDate={dayjs(selectedYearStart)}
                                  maxDate={dayjs(selectedYearEnd)}
                                  onChange={(newValue) => {
                                    // setValue("fromDate", newValue);
                                  }}
                                  error={Boolean(errors.fromDate)}
                                />
                              )}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group date-of-purchase">
                        <Index.FormHelperText className="lable-control">
                          To Date
                        </Index.FormHelperText>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <Controller
                              control={control}
                              {...register("toDate")}
                              render={({ field: { onChange, value } }) => (
                                <MobileDatePicker
                                  // disableFuture={true}
                                  className="custom-form-control"
                                  format="DD/MM/YYYY"
                                  value={value}
                                  minDate={dayjs(selectedYearStart)}
                                  maxDate={dayjs(selectedYearEnd)}
                                  onChange={(newValue) => {
                                    // setValue("toDate", newValue);
                                  }}
                                  error={Boolean(errors.toDate)}
                                />
                              )}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group date-of-purchase">
                        <Index.FormHelperText className="lable-control">
                          Letter Date
                        </Index.FormHelperText>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <Controller
                              control={control}
                              {...register("letterDate")}
                              render={({ field: { onChange, value } }) => (
                                <MobileDatePicker
                                  // disableFuture={true}
                                  className="custom-form-control"
                                  // minDate={dayjs(selectedYearStart)}
                                  // maxDate={dayjs(selectedYearEnd)}
                                  format="DD/MM/YYYY"
                                  value={value}
                                  onChange={(newValue) => {
                                    setValue("letterDate", newValue);
                                  }}
                                />
                              )}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group">
                        <Index.FormHelperText className="lable-control">
                          Ledger Group
                        </Index.FormHelperText>
                        <Index.Box className="dropdown-box auto-drop-box">
                          <Controller
                            control={control}
                            {...register("groups")}
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                className="custom-form-control"
                                options={groups || []}
                                limitTags={1}
                                autoHighlight
                                multiple
                                onChange={(e, value) => {
                                  onChange(value);
                                  setValue("accounts", []);
                                }}
                                getOptionLabel={(option) => option?.GroupName}
                                renderOption={(props, option) => (
                                  <Index.Box
                                    component="li"
                                    sx={{
                                      "& > img": {
                                        mr: 2,
                                        flexShrink: 0,
                                      },
                                    }}
                                    {...props}
                                  >
                                    {option?.GroupName}
                                  </Index.Box>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    error={Boolean(errors?.groups)}
                                    className="inner-custom-form-control"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group">
                        <Index.FormHelperText className="lable-control">
                          Accounts
                        </Index.FormHelperText>
                        <Index.Box className="dropdown-box auto-drop-box">
                          <Controller
                            control={control}
                            {...register("accounts")}
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                className="custom-form-control"
                                options={filteredAccounts || []}
                                autoHighlight
                                limitTags={1}
                                multiple
                                value={value}
                                onChange={(e, value) => {
                                  onChange(value);
                                }}
                                getOptionLabel={(option) => option?.accountName}
                                renderOption={(props, option) => (
                                  <Index.Box
                                    component="li"
                                    sx={{
                                      "& > img": {
                                        mr: 2,
                                        flexShrink: 0,
                                      },
                                    }}
                                    {...props}
                                  >
                                    {option?.accountName}
                                  </Index.Box>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    error={Boolean(errors?.accounts)}
                                    className="inner-custom-form-control"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group">
                        <Index.FormHelperText className="lable-control">
                          Ledger Having Balance
                        </Index.FormHelperText>
                        <Index.Box className="dropdown-box auto-drop-box">
                          <Controller
                            control={control}
                            {...register("balanceFilter")}
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                className="custom-form-control"
                                options={balanceFilterOptions || []}
                                value={balanceFilterOptions?.find(
                                  (e) => e?.value == value
                                )}
                                autoHighlight
                                onChange={(e, value) => {
                                  onChange(value?.value ? value?.value : "");
                                }}
                                getOptionLabel={(option) => option?.title}
                                renderOption={(props, option) => (
                                  <Index.Box
                                    component="li"
                                    sx={{
                                      "& > img": {
                                        mr: 2,
                                        flexShrink: 0,
                                      },
                                    }}
                                    {...props}
                                  >
                                    {option?.title}
                                  </Index.Box>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    error={Boolean(errors?.balanceFilter)}
                                    className="inner-custom-form-control"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group">
                        <Index.FormHelperText className="lable-control">
                          Address <span className="requried-star">*</span>
                        </Index.FormHelperText>
                        <Index.Box className="dropdown-box auto-drop-box">
                          <Controller
                            control={control}
                            {...register("selectedAddress", {
                              required: "Address is required.",
                            })}
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                className="custom-form-control"
                                options={addressType || []}
                                value={addressType?.find(
                                  (e) => e?.value == value
                                )}
                                autoHighlight
                                onChange={(e, value) => {
                                  onChange(value?.value ? value?.value : "");
                                }}
                                getOptionLabel={(option) => option?.title}
                                renderOption={(props, option) => (
                                  <Index.Box
                                    component="li"
                                    sx={{
                                      "& > img": {
                                        mr: 2,
                                        flexShrink: 0,
                                      },
                                    }}
                                    {...props}
                                  >
                                    {option?.title}
                                  </Index.Box>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    error={Boolean(errors?.selectedAddress)}
                                    className="inner-custom-form-control"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box stock-report-input-box webview-input-box">
                      <Index.Box className="form-group">
                        <Index.FormHelperText className="lable-control">
                          Report Type <span className="requried-star">*</span>
                        </Index.FormHelperText>
                        <Index.Box className="dropdown-box auto-drop-box">
                          <Controller
                            control={control}
                            {...register("reportType", {
                              required: "Report type is required.",
                            })}
                            render={({ field: { onChange, value } }) => (
                              <Autocomplete
                                className="custom-form-control"
                                options={reportType || []}
                                autoHighlight
                                onChange={(e, value) => {
                                  onChange(value?.value ? value?.value : "");
                                  setReportData([]);
                                }}
                                getOptionLabel={(option) => option?.title}
                                renderOption={(props, option) => (
                                  <Index.Box
                                    component="li"
                                    sx={{
                                      "& > img": {
                                        mr: 2,
                                        flexShrink: 0,
                                      },
                                    }}
                                    {...props}
                                  >
                                    {option?.title}
                                  </Index.Box>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    error={Boolean(errors?.reportType)}
                                    className="inner-custom-form-control"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                  />
                                )}
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box">
                      <Index.Box className="form-group">
                        <Index.Box className="checkbox-content-flex">
                          <Index.Box className="checkbox-main">
                            <Controller
                              className="checkbox"
                              control={control}
                              {...register("withNarration")}
                              render={({ field: { onChange, value } }) => (
                                <input
                                  type="checkbox"
                                  onChange={() =>
                                    setValue(
                                      "withNarration",
                                      !watch("withNarration")
                                    )
                                  }
                                  className="custom-form-control checkbox"
                                />
                              )}
                            />
                          </Index.Box>
                          <Index.Typography className="checkbox-lable">
                            With Narration
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box">
                      <Index.Box className="form-group">
                        <Index.Box className="checkbox-content-flex">
                          <Index.Box className="checkbox-main">
                            <Controller
                              className="checkbox"
                              control={control}
                              {...register("withMRP")}
                              render={({ field: { onChange, value } }) => (
                                <input
                                  type="checkbox"
                                  className="custom-form-control checkbox"
                                />
                              )}
                            />
                          </Index.Box>
                          <Index.Typography className="checkbox-lable">
                            With Voucher No.
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box">
                      <Index.Box className="form-group">
                        <Index.Box className="checkbox-content-flex">
                          <Index.Box className="checkbox-main">
                            <Controller
                              className="checkbox"
                              control={control}
                              {...register("printPaymentDetails")}
                              render={({ field: { onChange, value } }) => (
                                <input
                                  type="checkbox"
                                  className="custom-form-control checkbox"
                                  checked={
                                    watch("printPaymentDetails") ? true : false
                                  }
                                  onChange={() =>
                                    setValue(
                                      "printPaymentDetails",
                                      !watch("printPaymentDetails")
                                    )
                                  }
                                />
                              )}
                            />
                          </Index.Box>
                          <Index.Typography className="checkbox-lable">
                            With Payment Details
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box">
                      <Index.Box className="form-group">
                        <Index.Box className="checkbox-content-flex">
                          <Index.Box className="checkbox-main">
                            <Controller
                              className="checkbox"
                              control={control}
                              {...register("printPanTan")}
                              render={({ field: { onChange, value } }) => (
                                <input
                                  type="checkbox"
                                  className="custom-form-control checkbox"
                                  checked={watch("printPanTan") ? true : false}
                                  onChange={() =>
                                    setValue(
                                      "printPanTan",
                                      !watch("printPanTan")
                                    )
                                  }
                                />
                              )}
                            />
                          </Index.Box>
                          <Index.Typography className="checkbox-lable">
                            Print PAN/TAN
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box">
                      <Index.Box className="form-group">
                        <Index.Box className="checkbox-content-flex">
                          <Index.Box className="checkbox-main">
                            <Controller
                              className="checkbox"
                              control={control}
                              {...register("printGSTNo")}
                              render={({ field: { onChange, value } }) => (
                                <input
                                  type="checkbox"
                                  className="custom-form-control checkbox"
                                  checked={watch("printGSTNo") ? true : false}
                                  onChange={() =>
                                    setValue("printGSTNo", !watch("printGSTNo"))
                                  }
                                />
                              )}
                            />
                          </Index.Box>
                          <Index.Typography className="checkbox-lable">
                            Print GST No.
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box">
                      <Index.Box className="form-group">
                        <Index.Box className="checkbox-content-flex">
                          <Index.Box className="checkbox-main">
                            <Controller
                              className="checkbox"
                              control={control}
                              {...register("printAddress")}
                              render={({ field: { onChange, value } }) => (
                                <input
                                  type="checkbox"
                                  className="custom-form-control checkbox"
                                  checked={watch("printAddress") ? true : false}
                                  onChange={() =>
                                    setValue(
                                      "printAddress",
                                      !watch("printAddress")
                                    )
                                  }
                                />
                              )}
                            />
                          </Index.Box>
                          <Index.Typography className="checkbox-lable">
                            Print Address
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="input-box">
                      <Index.Box className="form-group">
                        <Index.Box className="checkbox-content-flex">
                          <Index.Box className="checkbox-main">
                            <Controller
                              className="checkbox"
                              control={control}
                              {...register("withMRP")}
                              render={({ field: { onChange, value } }) => (
                                <input
                                  type="checkbox"
                                  className="custom-form-control checkbox"
                                />
                              )}
                            />
                          </Index.Box>
                          <Index.Typography className="checkbox-lable">
                            A/c Bal. Confirmation
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box className="btn-flex-end ">
                      <Index.Box className="btn-primary-main webview-button-container">
                        <Index.Button
                          variant=""
                          className="btn-primary webview-submit-btn"
                          type="submit"
                        >
                          {isLoading ? (
                            <Index.Box className="webview-spinner-main">
                              <Index.CircularProgress className="webview-spinner"></Index.CircularProgress>
                            </Index.Box>
                          ) : (
                            "Submit"
                          )}
                        </Index.Button>
                      </Index.Box>
                    </Index.Box>
                  </form>
                  {pdfPreviewUrl ? (
                    <Index.Box className="btn-flex-end">
                      <Index.Box className="btn-secondary-main">
                        <ContainerIndex.LinearButton
                          btnLabel="View PDF"
                          className="btn-primary"
                          onClick={() => window.open(pdfPreviewUrl, "_blank")}
                        ></ContainerIndex.LinearButton>
                      </Index.Box>
                    </Index.Box>
                  ) : (
                    <></>
                  )}
                  {/* {reportData?.length ? (
                    <Index.Box className="btn-flex-end">
                      <Index.Box className="btn-secondary-main">
                        <ContainerIndex.LinearButton
                          btnLabel="Print"
                          className="btn-primary"
                          onClick={() => handlePrint()}
                        ></ContainerIndex.LinearButton>
                      </Index.Box>{" "}
                      <ContainerIndex.LinearButton
                        btnLabel="Excel"
                        className="btn-primary"
                        onClick={() => exportToExcel()}
                      ></ContainerIndex.LinearButton>
                    </Index.Box>
                  ) : (
                    <></>
                  )} */}
                  {reportContent(reportData)}
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </div>
    );
  }
}
